import { Box, Grid, MenuItem, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../component/table/tableCustom';
import { icons } from '../../constants/images';
import TableRowCommon from '../../component/table/TableRowCommon';
import { LayoutTitle, LayoutView, TitleText } from '../../component/layout/layoutMainStyle';
import ReportApi from '../../api/report/report.api';
import saveAs from 'file-saver';
import InputDatePicker from '../../component/input/inputDatePicker';
import moment from 'moment';
import AutocompleteSelect from '../../component/select/autoCompleteSelect';
import FilterSelect from '../../component/select/filterSelect';
import FolderApi from '../../api/folder/folder.api';
import DepartmentApi from '../../api/departments/departments.api';
import ButtonCustom from '../../component/button/buttonCustom';
import { getYearOptions } from '../../utils/app.utils';

export default function ReportSummaryByDepartment() {
    const [data, setData] = useState<any>([])
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [rowCount, setRowCount] = useState<number>(3);
    const [totalPages, setTotalPages] = useState<number>(3);
    const [totalItem, setTotalItem] = useState<number>(60);
    const [sdate, setSdate] = useState<string>('');
    const [edate, setEdate] = useState<string>('');
    const [keywordLevel1, setKeywordLevel1] = useState<string>('');
    const [keywordLevel2, setKeywordLevel2] = useState<string>('');
    const [keywordLevel3, setKeywordLevel3] = useState<string>('');
    const [keywordLevel4, setKeywordLevel4] = useState<string>('');
    const [idDepartment, setIdDepartment] = useState<number>();
    const [departments, setDepartments] = useState<any>([]);
    const [folderName, setFolderName] = useState<any>([]);
    const [idFiscalYear, setIdFiscalYear] = useState<number>();
        const yearOptions = getYearOptions();
    
    const loadData = useCallback(async () => {
        let condition: any = {};
        if (idDepartment) condition = { ...condition, idDepartment: idDepartment };
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear };
        if (keywordLevel1) condition = { ...condition, keywordLevel1: keywordLevel1 };
        if (keywordLevel2) condition = { ...condition, keywordLevel2: keywordLevel2 };
        if (keywordLevel3) condition = { ...condition, keywordLevel3: keywordLevel3 };
        if (keywordLevel4) condition = { ...condition, keywordLevel4: keywordLevel4 };
        if (sdate) condition = { ...condition, startDate: sdate };
        if (edate) condition = { ...condition, endDate: edate };

        ReportApi.getReportSummaryByDepartment(condition).then((res) => {
            if (res?.data?.success) {
                const data = res.data.result;
                setData(data);
            }
        });
    }, [idDepartment, idFiscalYear, keywordLevel1, keywordLevel2, keywordLevel3, keywordLevel4, sdate, edate]);

    useEffect(() => {
        loadData()
    }, [loadData])
    const loadFolderName = async () => {
        const res = await FolderApi.getFolderName()
        const data = await res.data;
        if (data?.success) {
            setFolderName(data.result)
        }
    }

    const getDepartments = async () => {
        const res = await DepartmentApi.getDepartments({})
        const data = res.data
        if (data.success) {
            setDepartments(data.result.items)
        }
    }

    useEffect(() => {
        loadFolderName()
        getDepartments()
    }, [])
    const download = async () => {
        let condition: any = {};
        if (idDepartment) condition = { ...condition, idDepartment: idDepartment };
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear };
        if (keywordLevel1) condition = { ...condition, keywordLevel1: keywordLevel1 };
        if (keywordLevel2) condition = { ...condition, keywordLevel2: keywordLevel2 };
        if (keywordLevel3) condition = { ...condition, keywordLevel3: keywordLevel3 };
        if (keywordLevel4) condition = { ...condition, keywordLevel4: keywordLevel4 };
        if (sdate) condition = { ...condition, startDate: sdate };
        if (edate) condition = { ...condition, endDate: edate };
        ReportApi.getReportSummaryByDepartmentDownload(condition).then((res) => {
            const data = res.data;
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'รายงานสถิติแยกตามแยกตามสำนัก');
        }
        );
    }



    const headCells = [
        {
            id: "no",
            label: 'ลำดับ',
            align: "center",
            colSpan: 1,
            width: '58px'
        },
        {
            id: "departmentName",
            label: 'สำนัก/กอง',
            align: "left",
            colSpan: 1,
        },
        {
            id: "fileCount",
            label: 'จำนวนไฟล์',
            align: "left",
            colSpan: 1,
        },
        {
            id: "sumFileSize",
            label: 'ขนาดไฟล์ทั้งหมด',
            align: "left",
            colSpan: 1,
        },
    ];


    const renderData = (objData: any, index: any) => {
        const { sumFileSize, fileCount, departmentName } = objData;
        index = page * pageLimit - pageLimit + index + 1;

        const objRenderData = {
            key: index,
            id: index,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: index },
                { option: "TEXT", align: "left", label: departmentName },
                { option: "TEXT", align: "left", label: fileCount },
                { option: "TEXT", align: "left", label: (sumFileSize / 1000000)?.toFixed(2)?.toLocaleString() + ' MB' },

            ],

        }


        return (
            <TableRowCommon
                {...objRenderData}
                ondocumentdetail={() => { }}
            />
        )
    };
    return (
        <LayoutView>
            <LayoutTitle>
                <TitleText>รายงานสถิติแยกตามแยกตามสำนัก</TitleText>
            </LayoutTitle>
            <Grid container columns={14} sx={{ marginBottom: '12px', display: 'flex', }}>
                <Grid md={2} xs={14} sx={{ marginRight: { lg: '10px', xs: '0px' } }}>
                    <InputDatePicker
                        dateFormat="DD/MM/YYYY"
                        required={false}
                        key={""}
                        disabled={false}
                        label=""
                        value={sdate}
                        onClear={() => setSdate('')}
                        onChange={(e: any) => setSdate(moment(e).format("YYYY-MM-DD"))
                        }
                        allowClear
                        heading={'ตั้งแต่วันที่'} />
                </Grid>
                <Grid md={2} xs={14} sx={{ marginRight: { lg: '10px', xs: '0px' } }}>

                    <InputDatePicker
                        dateFormat="DD/MM/YYYY"
                        required={false}
                        key={""}
                        disabled={false}
                        label=""
                        value={edate}
                        onClear={() => setEdate('')}
                        onChange={(e: any) => setEdate(moment(e).format("YYYY-MM-DD"))
                        }
                        allowClear
                        heading={'ถึงวันที่'} />
                </Grid>
                <Grid md={3} xs={14} sx={{ marginRight: { lg: '10px', xs: '0px' } }}>
                    <AutocompleteSelect
                        options={folderName?.level1}
                        // disabled={location.state.params.isView}
                        getOptionLabel={(option: any) => option}
                        labelId="addmin-type"
                        inputValue={keywordLevel1}
                        heading={'ตู้เอกสาร/หน่วยงาน'}
                        placeholder='ทั้งหมด'
                        onInputChange={(event, newValue) => {
                            setKeywordLevel1(newValue)
                        }}
                        // required
                        helperText={''}
                    />
                </Grid>
                <Grid md={3} xs={14} sx={{ marginRight: { lg: '10px', xs: '0px' } }}>
                    <AutocompleteSelect
                        options={folderName?.level2}
                        // disabled={location.state.params.isView}
                        getOptionLabel={(option: any) => option}
                        labelId="addmin-type"
                        inputValue={keywordLevel2}
                        heading={'ชั้นเอกสาร'}
                        placeholder='ทั้งหมด'
                        onInputChange={(event, newValue) => {
                            setKeywordLevel2(newValue)
                        }}
                        // required
                        helperText={''}
                    />
                </Grid>
                <Grid md={3} xs={14} sx={{ marginRight: { lg: '10px', xs: '0px' } }}>
                    <AutocompleteSelect
                        options={folderName?.level3}
                        // disabled={location.state.params.isView}
                        getOptionLabel={(option: any) => option}
                        labelId="addmin-type"
                        inputValue={keywordLevel3}
                        heading={'แฟ้มเอกสาร'}
                        placeholder='ทั้งหมด'
                        onInputChange={(event, newValue) => {
                            setKeywordLevel3(newValue)
                        }}
                        // required
                        helperText={''}
                    />
                </Grid>
                <Grid md={3} xs={14} sx={{ marginRight: { lg: '10px', xs: '0px' } }}>
                    <AutocompleteSelect
                        options={folderName?.level4}
                        // disabled={location.state.params.isView}
                        getOptionLabel={(option: any) => option}
                        labelId="addmin-type"
                        inputValue={keywordLevel4}
                        heading={'ประเภทเอกสาร'}
                        placeholder='ทั้งหมด'
                        onInputChange={(event, newValue) => {
                            setKeywordLevel4(newValue)
                        }}
                        // required
                        helperText={''}
                    />
                </Grid>
                <Grid md={2} xs={14} sx={{ marginRight: { lg: '10px', xs: '0px' } }}>
                    <FilterSelect heading='หน่วยงาน' labelId='' selectId='' options={departments.map((x: any, i: number) => {
                        return (
                            <MenuItem key={i}
                                value={x.idDepartment}
                            >
                                {x.departmentName}
                            </MenuItem>
                        )
                    })} value={idDepartment} onchange={(e: any) => { setIdDepartment(e.target.value) }} />
                </Grid>
                <Grid md={2} xs={14} sx={{ marginRight: { lg: '10px', xs: '0px' } }}>
                    <FilterSelect heading='ปีงบประมาณ' labelId='' selectId='' options={yearOptions.map((x, i) => {
                        return (
                            <MenuItem key={i}
                                value={x.value}
                            >
                                {x.name}
                            </MenuItem>
                        )
                    })} value={idFiscalYear} onchange={(e: any) => { setIdFiscalYear(e.target.value) }} />
                </Grid>
                <Grid md={6} xs={14} sx={{ display: 'flex', alignItems: 'end', justifyContent: "end", marginTop: { lg: '0px', xs: '10px' } }}>
                    <ButtonCustom textButton={'ดาวน์โหลด'} onClick={() => download()} />
                </Grid>
            </Grid>
            <TableCustom
                headCells={headCells}
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortType={"ASC"}
                sortBy=""
                rowCount={rowCount}
                rowsData={[...data?.map((d: any, index: any) => {
                    return renderData(d, index);
                }),
                <TableRowCommon
                    columns={[
                        { option: "TEXT", align: "left", label: 'ผลรวม' },
                        { option: "TEXT", align: "left", label: '' },

                        {
                            option: "TEXT", align: "left", label: data.reduce((total: any, item: any) => {
                                return total + parseInt(item.fileCount, 10);
                            }, 0)
                        },
                        {
                            option: "TEXT", align: "left", label: (data.reduce((total: any, item: any) => {
                                return total + parseInt(item.sumFileSize, 10);
                            }, 0) / 1000000)?.toFixed(2)?.toLocaleString() + ' MB'
                        },
                    ]}
                    ondocumentdetail={() => { }} key={''} id={''} obj={undefined} />]}
                onSort={() => { }}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
                totalPages={totalPages}
                totalItem={totalItem}
                hidePagination
            />
        </LayoutView>
    )
}
